export { SvgComponent } from "./svg.component";
export { IconName } from "./svg.model";
